function OrganizationCtrl($rootScope, $state, analyticsService, sdkOrganizationService, organizationService) {
  analyticsService.identifyOrganization();

  const currentUserOrganization = organizationService.getCurrentOrganization();

  const checkOrgEnabledInterval = setInterval(() => {
    sdkOrganizationService.readById(currentUserOrganization.id)
      .then(org => {
        if (!org.enabled) {
          clearInterval(checkOrgEnabledInterval);

          $state.go('app.selectOrganization');
        }
      })
      .catch(() => {
        clearInterval(checkOrgEnabledInterval);
      });
  }, 3600000); //every hour
}

OrganizationCtrl.$inject = [
  '$rootScope',
  '$state',
  'analyticsService',
  'jsSdk.organization',
  'organizationService'
];

export default OrganizationCtrl;



// WEBPACK FOOTER //
// ./src/components/organization/organizationCtrl.js